const comments = [
  {
    name: '吃瓜一线战士',
    time: '3小时前',
    content: '这个站真的太牛了，每次有大瓜都是第一时间更新！比微博热搜还快，已经推荐给身边所有爱吃瓜的朋友了。',
    likes: '2.3万',
    avatar: 'primary',
  },
  {
    name: '八卦小能手',
    time: '6小时前',
    content: '之前一直找不到靠谱的吃瓜渠道，自从发现了911黑料网，感觉打开新世界大门。内容真实有料，不像其他营销号乱编。',
    likes: '1.8万',
    avatar: 'accent',
  },
  {
    name: '深夜吃瓜人',
    time: '9小时前',
    content: '每天晚上睡前必刷一遍，已经成了习惯。编辑团队真的很专业，文章深度和速度都是一流的，吃瓜体验满分。',
    likes: '1.5万',
    avatar: 'secondary',
  },
  {
    name: '娱乐圈老司机',
    time: '12小时前',
    content: '作为混迹娱乐圈多年的老司机，我可以负责任地说，911黑料网的爆料准确率是最高的。很多所谓的黑料后来都被官方证实了。',
    likes: '9800',
    avatar: 'primary',
  },
  {
    name: '匿名吃瓜群众',
    time: '1天前',
    content: '保护隐私这点做得很好，我之前投过一次料，全程匿名而且编辑还帮我做了脱敏处理。希望平台越做越好，继续守护真相！',
    likes: '7600',
    avatar: 'accent',
  },
];

const avatarColors: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">吃瓜评论</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((cmt, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 font-bold text-sm ${avatarColors[cmt.avatar]}`}
                >
                  {cmt.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{cmt.name}</div>
                  <div className="text-xs text-foreground-400">{cmt.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cmt.content}</p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {cmt.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}